import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import styles from "./subCategory.module.css";

const SubCategory = ({
  cat,
  index,
  filter,
  childFilter,
  setChildFilter,
  subCategory,
  subFilter,
  setSubFilter,
  setCurrentSubCat,
  page,
}) => {
  const [showChildCat, setShowChildCat] = useState(false);
  return (
    <>
      <Box className={styles.sub_filter_wrapper}>
        <Button
          key={index}
          onMouseEnter={() => setShowChildCat(true)}
          onMouseLeave={() => setShowChildCat(false)}
          className={
            page == "MyAccount"
              ? cat.id == subFilter
                ? `${styles.sub_filter_Acc} ${styles.active}`
                : `${styles.sub_filter_Acc}`
              : page == "leaderboard-admin"
              ? cat.id == subFilter
                ? `${styles.sub_filter_admin} ${styles.active}`
                : `${styles.sub_filter_admin}`
              : cat.id == subFilter
              ? `${styles.sub_filter} ${styles.active}`
              : `${styles.sub_filter}`
          }
          onClick={() => {
            setSubFilter(cat.id);
            setCurrentSubCat(cat);
            setChildFilter(null);
          }}
        >
          <Typography component="h1" className="text">
            {cat.name}
          </Typography>
        </Button>
      </Box>
    </>
  );
};

export default SubCategory;
